import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../common/config";

export const loginService = createApi({
  reducerPath: "login",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api",
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (formdata) => ({
        url: "/users/login",
        method: "POST",
        body: formdata,
      }),
    }),
  }),
});
export const { useLoginMutation } = loginService;
